import React, { useState } from 'react';
import { Box, Card, IconButton, Typography } from '@mui/material';
import { FileCopyOutlined } from '@mui/icons-material';
import { useL10n } from '@uplift/hooks';
import { Button, ClickToCopy } from '@uplift/ui-v2';
import { useHelpCenterStyles } from './support-page-styles';
import { SubmitRequestModal } from './submit-request-modal';

export const SubmitRequestCard: React.VFC = () => {
  const { classes } = useHelpCenterStyles();
  const l10n = useL10n();
  const [ modalOpen, setModalOpen ] = useState(false);

  return (
    <>
      <Card className={classes.contactCard}>
        <Typography variant="subtitle1" className={classes.contactCardTitle}>
          {l10n.support.submitRequestTitle}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {l10n.support.submitRequestDesc}
        </Typography>
        <Box className={classes.submitButtonRow}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setModalOpen(true)}
          >
            {l10n.support.submitRequestTitle}
          </Button>
        </Box>
      </Card>
      <SubmitRequestModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export const CallUsCard: React.VFC = () => {
  const { classes } = useHelpCenterStyles();
  const l10n = useL10n();

  return (
    <Card className={classes.contactCard}>
      <Typography variant="subtitle1" className={classes.contactCardTitle}>
        {l10n.support.callUsTitle}
      </Typography>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="h6">
          {l10n.support.supportNumber}
        </Typography>
        <ClickToCopy text={l10n.support.supportNumber}>
          <IconButton size="small">
            <FileCopyOutlined fontSize="inherit" />
          </IconButton>
        </ClickToCopy>
      </Box>
      <Typography variant="body2" color="textSecondary">
        {l10n.support.callUsAvailability}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {l10n.support.faxUs(l10n.support.supportFax)}
      </Typography>
    </Card>
  );
};

export const EmailUsCard: React.VFC = () => {
  const { classes } = useHelpCenterStyles();
  const l10n = useL10n();

  return (
    <Card className={classes.contactCard}>
      <Typography variant="subtitle1" className={classes.contactCardTitle}>
        {l10n.support.emailUsTitle}
      </Typography>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="h6">
          {l10n.support.supportEmail}
        </Typography>
        <ClickToCopy text={l10n.support.supportEmail}>
          <IconButton size="small">
            <FileCopyOutlined fontSize="inherit" />
          </IconButton>
        </ClickToCopy>
      </Box>
      <Typography variant="body2" color="textSecondary">
        {l10n.support.emailUsReplyTime}
      </Typography>
    </Card>
  );
};
